import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import ModalBody from './ModalBody';
import { ExclamationCircleOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = ({setModalVisible, modalVisible, setUpdate, update}) => {
  const [results, setResults] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedPromoCode, setSelectedPromoCode] = useState(null);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');
  const { confirm } = Modal;

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    try {
      const res = await axios.post(`${URL}/promo/get_promo_code.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log(error);

    }
  }

  const openEditModal = (promoCode) => {
    setUpdate(update + 1);
    setEditModalVisible(true);
    setSelectedPromoCode(promoCode);
  }

  const deletePromoCode = (promoCode) => {
    confirm({
      title: 'Are you sure delete this promo code?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        console.log('OK');
        deletePromoCodeWithId(promoCode.Id);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deletePromoCodeWithId = async (promoCodeId) => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('Id', promoCodeId);

    dispatch(enableSpinner('Deleting..'));
    const res = await axios.post(`${URL}/promo/delete_promo_code.php`, bodyFormData);
    dispatch(disableSpinner());

    if(res.data.Success) {
      message.success(res.data.Message);
      loadResults();
    } else {
      message.error(res.data.Message);
    }
  }

  const handleSubmit = async (values, index) => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('Code', values.code);
    bodyFormData.append('Percent', values.percent);

    try {
      console.log("Values", values);
      if(index === 0) {
        setModalVisible(false);

        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/promo/add_promo_code.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      } else {
        setEditModalVisible(false);

        bodyFormData.append('Id', selectedPromoCode.Id);

        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/promo/update_promo_code.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      }
    }catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  const columns = [
    {
      title: 'Promo Code',
      dataIndex: 'Code',
      key: 'Code',
    },
    {
      title: 'Discount Percent',
      dataIndex: 'Percent',
      key: 'Percent',
    },
    {
      title: 'Edit',
      dataIndex: '',
      key: 'edit',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => openEditModal(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <EditOutlined />
          </span>
        )
      }
    },
    {
      title: 'Delete',
      dataIndex: '',
      key: 'delete',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => deletePromoCode(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <DeleteOutlined />
          </span>
        )
      }
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
      <Modal
        title={`Add Promo Code`}
        width="30%"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        footer={null}
      >
      <ModalBody close={() => setModalVisible(false)} handleSubmit={(values) => handleSubmit(values, 0)} update={update} />
      </Modal>

      <Modal 
        title="Edit Promo Code"
        width="30%"
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        footer={null}>
          <ModalBody 
            close={() => {setSelectedPromoCode(null); setEditModalVisible(false); }} 
            handleSubmit={(values) => handleSubmit(values, 1)}
            promoCode={selectedPromoCode}
            update={update} />
        </Modal>
    </Col>
  );
}



export default ExampleCard;
